<template>
  <div>
    <a-row>
      <a-tabs :defaultActiveKey="activeEmpKey">
        <a-tab-pane v-if="visibleProyectos" tab="PROYECTOS" key="1">
          <g-master name="project"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    modalWidth="80%"
          >
            <span slot="estadoRenderer" slot-scope="{text}">
              <a-tag :color="text==='PENDIENTE' ? 'red' : (text === 'COMPLETO' ? 'green' : 'blue')">{{text}}</a-tag>
            </span>
            <template slot="expandedRowRender" slot-scope="{text}">
              <template v-for="ve in master.valoresExpandidos">
                {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
              </template>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="company"
                              :label="$t('Compañía')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_company', { rules: [{ required: false }] }]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
                    <a-input
                      v-decorator="['project_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha inicio')">
                    <a-date-picker style="width: 100%" valueFormat="Y-MM-DD 00:00:00"
                                   v-decorator="['ini_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                    ></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha fin')">
                    <a-date-picker style="width: 100%" valueFormat="Y-MM-DD 00:00:00"
                                   v-decorator="['end_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                    ></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="$t('Estado')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_h_status_project', { rules: [{ required: false }] }]"
                              :params="estado_proyecto">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Comentarios')">
                    <a-textarea autoSize
                      v-decorator="['comments', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
          <a-tabs defaultActiveKey="1">
            <a-tab-pane :tab="$t('PERSONAS INVOLUCRADAS')" key="1">
              <project_personas v-if="idProyecto" :project_id="idProyecto"></project_personas>
              <span v-else>Seleccione un proyecto para ver más.</span>
            </a-tab-pane>
            <a-tab-pane :tab="$t('TAREAS')" key="2">
              <project_tasks v-if="idProyecto" :project_id="idProyecto"></project_tasks>
              <span v-else>Seleccione una proyecto para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
        <a-tab-pane tab="TAREAS ASIGNADAS" key="2">
          <project_task_person></project_task_person>
        </a-tab-pane>
      </a-tabs>
    </a-row>

    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        activeEmpKey: 0,
        estado_proyecto: {
          h_lookup_type: 'GP_ESTADO_PROYECTOYTAREAS'
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado el', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado el', column: 'modified_on'}
          ],
          endpoint: 'project',
          tableSetup: {
            customSlots: ['estadoRenderer', 'expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Proyecto', dataIndex: 'project_name', sorter: true, width: 250},
              {title: 'Compañía', dataIndex: 'company', sorter: true, width: 200},
              {title: 'Comentarios', dataIndex: 'comments', sorter: true, width: 500},
              {title: 'Fecha Inicio', dataIndex: 'f_ini', sorter: true},
              {title: 'Fecha Fin', dataIndex: 'f_fin', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                width: 105,
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              }
            ],
            allowSelect: true,
            selectedRows: []
          }
        }
      }
    },
    computed: {
      idProyecto () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      },
      visibleProyectos () {
        if (this.$userIsInrol('GestionDeProyectos')) {
          this.activeEmpKey = 1
          return true
        } else {
          this.activeEmpKey = 2
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/GestionDeProyectos/Project.vue